import React, { FC } from 'react';

import AgeCategorySelector from '../../shared/common/AgeCategorySelector';
import TitleDropdown from '../../shared/navigation/TitleDropdown';
import { LinkContainer } from '../../shared/navigation/NavigationLinksContainer';
import SubNavigationLayout from '../../shared/navigation/SubNavigationLayout';
import { NavigationLink } from '../../shared/navigation/NavigationLink';
import { useTranslation } from 'react-i18next';

type Props = {
    readonly isSticky?: boolean;
    readonly showAgeSelector?: boolean;
};

const LibxNavigation: FC<Props> = ({ isSticky, showAgeSelector }) => {
    const { t } = useTranslation();
    return (
        <SubNavigationLayout
            left={<TitleDropdown isLibx={true} locationPathname={undefined} />}
            center={
                <LinkContainer>
                    <li>
                        <NavigationLink to="/libxchange/featured">{t('menu.shop.libxchange.featured')}</NavigationLink>
                    </li>
                    <li>
                        <NavigationLink to="/libxchange/newlyadded">
                            {t('menu.shop.libxchange.newlyAdded')}
                        </NavigationLink>
                    </li>
                    <li>
                        <NavigationLink to="/libxchange/products">{t('menu.shop.libxchange.allTitles')}</NavigationLink>
                    </li>
                    <li>
                        <NavigationLink to="/libxchange/genres">{t('menu.shop.libxchange.genres')}</NavigationLink>
                    </li>
                    <li>
                        <NavigationLink to="/libxchange/localregions">
                            {t('menu.shop.libxchange.localRegions')}
                        </NavigationLink>
                    </li>
                </LinkContainer>
            }
            right={!isSticky && showAgeSelector && <AgeCategorySelector />}
            isSticky={isSticky}
            width="30"
        />
    );
};

export default LibxNavigation;
